import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowDown"><Path d="M18.5 14L12 20.5L5.5 14" stroke="currentColor" strokeLinecap="square"/><Path d="M12 20V3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowDown;
